<template>
  <div>
    <Teleport to="#settings-group-header">
      <T>Подключение к r_keeper</T>
    </Teleport>
    
    <Teleport to="#settings-group-actions">
      <v-btn
        text
        color="primary"
        @click="save"
        :loading="loading"
        :disabled="loading"
      >
        <v-icon>mdi-content-save</v-icon>
        <T>Сохранить</T>
      </v-btn>
    </Teleport>
    
    <RKeeper :loading="loading" :config="$store.getters.config" ref="form"/>
  </div>
</template>

<script>

import Teleport from 'vue2-teleport'
import RKeeper from '../../components/settings/r_keeper'

export default {
  data: () => ({
    loading: false
  }),
  methods: {
    async save(){
      this.loading = true
      try {
        let new_config = this.$refs.form.submit()

        await this.$store.dispatch('updateConfig', new_config)

        this.$store.dispatch('throwTimeoutMessage', {
          message_data: this.$t('Изменения сохранены'),
          message_class: 'success'
        })

        this.$refs.form.ping()
      } catch (e) {
        this.$store.dispatch('throwTimeoutMessage', {
          message_data: `${e.message}`,
          message_class: 'error'
        })
        this.loading = false
      } finally {
        this.loading = false
      }
    }
  },
  components: {
    Teleport,
    RKeeper
  }
}
</script>